import React, { useState } from "react";
import {Link,useNavigate} from "react-router-dom";
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import SvgIcon from "@common/SvgIcon";
import Fade from '@mui/material/Fade';

const SettingsMenu = ({settingsItems,classes})=>{
    const navigate = useNavigate();
    const handleClose = ()=>setMenuEl(null);
    const [menuEl,setMenuEl] = useState(null);
    const navigateTo = (path) => {
        navigate(path);
        handleClose();
    }
    const openMenu = (e)=>{
        e.preventDefault();
        setMenuEl(e.currentTarget);
    }
    return<>
        {!!settingsItems.length && <div className="iconList">
            <a href="#" onClick={openMenu} title="Settings">
                <SvgIcon icon="/static/images/settings.svg" size="medium"/>
            </a>
        </div>} 
        <Menu
            id="settings-menu"
            anchorEl={menuEl}
            keepMounted
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            autoFocus={false}
            open={Boolean(menuEl)}
            onClose={handleClose}
            TransitionComponent={Fade}
            slotProps={{
                  paper: {
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 0.5,
                      background:'#FAFBFF',
                      '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: '14px',
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  }
                }}
            >
            {settingsItems.map(item => (
                <MenuItem key={item.label} onClick={()=>navigateTo(item.to)}>
                    <Link className={`h-menuItem ${classes.dFlex} ${(window.location.pathname === item.to) ? classes.activeMenu : classes.menuItem}`} key={item.label} to={item.to} onClick={handleClose}>
                        <SvgIcon icon={item.icon} size="normal" className="mr-6"/>
                        {item.label}
                    </Link>
                </MenuItem>
            ))}
        </Menu>
    </>
}

export default SettingsMenu;